module.exports = __webpack_public_path__ + "img/balkongelaender_rot.25146738.webp";